import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_URL } from "../data";

export const LegalLayout = ({ title, children }) => {
  return (
    <div className="min-h-screen bg-[#05070D]">
      <header className="border-b border-white/10 bg-[#05070D]/90 backdrop-blur-xl">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-5 py-4 md:px-8">
          <Link to="/" className="flex items-center gap-3" data-testid="legal-logo">
            <img src={LOGO_URL} alt="TSU-Partners" className="h-10 w-10 rounded-xl object-cover ring-1 ring-white/15" />
            <span className="font-heading text-base font-extrabold text-white">
              TSU<span className="gradient-text">-PARTNERS</span>
            </span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back"
            className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 text-sm font-semibold text-gray-200 transition-colors hover:text-white"
          >
            <ArrowLeft className="h-4 w-4" /> Zurück
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 py-16 md:px-8">
        <h1 className="mb-10 font-heading text-3xl font-extrabold text-white md:text-4xl">{title}</h1>
        <div className="space-y-8 text-[15px] leading-relaxed text-gray-300">{children}</div>
      </main>
    </div>
  );
};

const Block = ({ heading, children }) => (
  <section>
    {heading && <h2 className="mb-2 font-heading text-lg font-bold text-white">{heading}</h2>}
    <div className="space-y-2">{children}</div>
  </section>
);

export { Block };
